export const PageHero = {
  flow: 'y',
  gap: 'A',
  padding: 'C',
  maxWidth: 'L+L',
  width: '100%',
  margin: '0 auto',
  position: 'relative',
  borderBottomWidth: 'hairline',
  borderBottomColor: 'line',
  borderBottomStyle: 'solid',

  Eyebrow: {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    fontSize: 'V',
    fontWeight: '700',
    letterSpacing: '.18em',
    // §8.5 rule 2 — this eyebrow is the single most-repeated accent-ink site
    // in the shell (19 measured instances across ~10 routes: /tasks*,
    // /resolutions, /tickets*, …), and brand blue as bold ink on the
    // gray14-class page wash measured 2.77:1. The leading Dot keeps the raw
    // hue — a shape carries no contrast floor.
    color: 'accentInk',
    Dot: {
      width: 'V',
      height: 'V',
      round: '50%',
      background: 'blue'
    },
    Text: { tag: 'span', text: (el) => el.parent.parent.eyebrow || '' }
  },

  Headline: {
    // One title per host (design-direction.md §3): every consumer's headline
    // is its view name, which a pane title bar already shows. The eyebrow and
    // the lede (the live counts) stay.
    hide: (el, s) => el.call('paneTitleBarShown', s),
    tag: 'h1',
    margin: '0',
    fontSize: 'F1',
    fontWeight: '700',
    letterSpacing: '-.025em',
    lineHeight: '0.95',
    color: 'title',
    text: (el, s) => {
      const h = el.parent.headline
      return typeof h === 'function' ? h(el, s) : h || ''
    }
  },

  Lede: {
    tag: 'p',
    margin: '0',
    maxWidth: 'L',
    fontSize: 'B',
    lineHeight: '1.5',
    fontWeight: '400',
    color: 'subtitle',
    text: (el, s) => {
      const l = el.parent.lede
      return typeof l === 'function' ? l(el, s) : l || ''
    }
  }
}
